import moment from "moment";

const baseColumns = [
  {
    title: "满载率申请结果",
    dataIndex: "loadFactorApproveStatus",
    scopedSlots: { customRender: "loadFactorApproveStatus" },
    width: 150,
  },
  {
    title: "费用差申请结果",
    dataIndex: "expenseVarianceApproveStatus",
    scopedSlots: { customRender: "expenseVarianceApproveStatus" },
    width: 150,
  },
  {
    title: "修改计划申请结果",
    dataIndex: "msgPlanModifyApproveStatus",
    scopedSlots: { customRender: "msgPlanModifyApproveStatus" },
    width: 150,
  },
];

export const tableColumns = [
  {
    title: "计划单名称",
    dataIndex: "planName",
    scopedSlots: { customRender: "planName" },
    width: 220,
    fixed: "left",
  },
  {
    title: "结果",
    dataIndex: "result",
    scopedSlots: { customRender: "result" },
    width: 260,
  },
  {
    title: "预估运费",
    dataIndex: "transportPrice",
    customRender: (text) => text || "--",
    width: 120,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    customRender: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    width: 180,
  },
  {
    title: "提交人",
    dataIndex: "createUserName",
    scopedSlots: { customRender: "createUser" },
    width: 120,
  },
  {
    title: "排线规则",
    dataIndex: "planMethod",
    width: 110,
  },
  ...baseColumns,
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 320,
    fixed: "right",
  },
];

export const planTableColumns = [
  {
    title: "计划单名称",
    dataIndex: "planName",
    scopedSlots: { customRender: "planName" },
    width: 220,
    fixed: "left",
  },
  {
    title: "结果",
    dataIndex: "result",
    scopedSlots: { customRender: "result" },
    width: 260,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    customRender: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    width: 180,
  },
  {
    title: "提交人",
    dataIndex: "createUserName",
    scopedSlots: { customRender: "createUser" },
    width: 120,
  },
  {
    title: "排线规则",
    dataIndex: "planMethod",
    width: 110,
  },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    width: 100,
  },
  ...baseColumns,
  {
    title: "操作",
    dataIndex: "planAction",
    scopedSlots: { customRender: "planAction" },
    width: 320,
    fixed: "right",
  },
];
// 排线规则
export const PLAN_METHOD = [
  {
    label: "满载率最优",
    value: "满载率最优",
    disabled: true,
  },
  {
    label: "成本最优",
    value: "成本最优",
  },
];

export const PROCESSEDCOLUMN = [
  {
    title: "计划单",
    dataIndex: "planName",
    scopedSlots: { customRender: "planName" },
    minWidth: 120,
  },
  {
    title: "确认时间",
    dataIndex: "confirmTime",
    ellipsis: true,
    width: 150,
  },
  {
    title: "待处理订单数",
    dataIndex: "pendingCount",
    ellipsis: true,
    width: 140,
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    dataIndex: "action",
    width: 100,
  },
];

export const SINGLEPLANCOLUMN = [
  {
    title: "日期",
    dataIndex: "planTime",
    ellipsis: true,
    width: 120,
  },
  {
    title: "集散中心",
    dataIndex: "entrepot",
    ellipsis: true,
  },
  {
    title: "仓库",
    dataIndex: "warehouseCode",
    ellipsis: true,
  },
  {
    title: "拍数",
    dataIndex: "skuPallet",
    ellipsis: true,
    width: 80,
  },
  {
    title: "箱数",
    dataIndex: "skuAmount",
    ellipsis: true,
    width: 80,
  },
  {
    title: "拍数向上取整",
    ellipsis: true,
    dataIndex: "skuPalletUpper",
    width: 110,
  },
];

// 计划单状态
const planStatus = {
  PLANED: "PLANED",
  TO_BE_PLAN: "TO_BE_PLAN",
  TO_BE_CONFIRMED: "TO_BE_CONFIRMED",
  CONFIRMED: "CONFIRMED",
  DELETED: "DELETED",
  OVERTIME: "OVERTIME",
  IMPORT_FAILED: "IMPORT_FAILED",
  DRAFT: "DRAFT",
};

export const PLAN_STATUS = planStatus;

export const PLANSTATUSEMU = {
  [planStatus.TO_BE_PLAN]: "待排线",
  [planStatus.TO_BE_CONFIRMED]: "待确认",
  [planStatus.CONFIRMED]: "已确认",
  [planStatus.DELETED]: "已删除",
  [planStatus.DRAFT]: "草稿",
  [planStatus.OVERTIME]: "排线超时",
  [planStatus.IMPORT_FAILED]: "导入数据错误",
};

export const PLANSTATUSRESULTEMU = {
  [null]: "未发送",
  1: "待审批",
  2: "同意",
  3: "驳回",
};
